import React from 'react';
import Page from '@/wpt-lib/pdf/common/Page';
import SectionComments from '@/wpt-lib/pdf/SectionComments';
import useData, { useLabels } from '@/wpt-lib/pdf/useData';
import { WorkplanCommentSection } from '@/wpt-lib/interfaces/WorkplanComment';
import Heading from '@/wpt-lib/pdf/common/Heading';
import { Row, Table, ValueCell } from '@/wpt-lib/pdf/common/Table';

const Behavioural = () => {
    const comments = useData().comments.filter((c) => c.section === WorkplanCommentSection.BEHAVIOURAL);
    const behaviouralKpi = useLabels('behaviouralKpi');

    return typeof behaviouralKpi === 'string' ? (
        <Page>
            <Heading text="Positive Conduct and Behaviour" />
            <Table cols={1}>
                <Row>
                    <ValueCell label="Key Performance Indicators (KPIs)" value={'' + behaviouralKpi} />
                </Row>
            </Table>
            <SectionComments heading="Positive Conduct and Behaviour Comments" comments={comments} />
        </Page>
    ) : null;
};

export default Behavioural;
